import { Directive, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputRange]',
  standalone: true
})
export class InputRangeDirective implements OnInit{
  @Input() min: number = 0;
  @Input() max: number = 0;

  constructor(private ngControl: NgControl) { }


  ngOnInit(): void {
    const ctrl = this.ngControl.control!;

    ctrl.valueChanges
      .subscribe((v) => {
        if (v > this.max) {
          ctrl.setValue(this.max, { emitEvent: false });
        }
        if (v < this.min) {
          ctrl.setValue(this.min, { emitEvent: false });
        }
      });
    }

}
